jQuery(function () {
  if (document.body.classList.contains("block-editor-page")) return;

  const blocks = document.querySelectorAll(".js-witf");
  if (!blocks.length) return;

  const gsap = window.gsap;
  if (!gsap) return;

  const debounce =
    (gsap.utils && typeof gsap.utils.debounce === "function"
      ? gsap.utils.debounce
      : (fn, wait = 150) => {
          let t;
          return (...args) => {
            window.clearTimeout(t);
            t = window.setTimeout(() => fn(...args), wait);
          };
        });

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

  blocks.forEach((block) => {
    if (block.dataset.init === "1") return;
    block.dataset.init = "1";

    const content = block.querySelector(".witf__content");
    const marquee = block.querySelector(".witf__marquee");
    const track = block.querySelector(".witf__track");

    // === REVEAL ===
    if (!prefersReduced) {
      const targets = [content, marquee].filter(Boolean);

      gsap.set(targets, { opacity: 0, y: 20 });

      gsap.to(targets, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        stagger: 0.15,
        scrollTrigger: window.ScrollTrigger
          ? { trigger: block, start: "top 80%", once: true }
          : undefined,
      });
    }

    // === MARQUEE (IDENTICAL TO CTA) ===
    if (!track || prefersReduced) return;

    const speed = 90;

    let tween;

    const run = () => {
      gsap.killTweensOf(track);
      gsap.set(track, { x: 0 });

      const half = track.scrollWidth / 2;
      if (!half) return;

      tween = gsap.to(track, {
        x: -half,
        duration: half / speed,
        ease: "none",
        repeat: -1,
      });
    };

    run();

    const onResize = debounce(run, 150);
    window.addEventListener("resize", onResize);

    if (block.classList.contains("is-pause-hover")) {
      block.addEventListener("mouseenter", () => tween?.pause());
      block.addEventListener("mouseleave", () => tween?.resume());
    }
  });
});
